/* Nikura homepage + menu search GA4 events (colleagues' sheet rows 34-43 + 45, columns F/G/H).
   menu_search              {location_id, action, search_term}         search bar inside the menu drawer:
                            action 'focus' (once per visit to the bar), 'type' (once per visit, when typing
                            pauses for 1 s), 'submit' (search sent). search_term is the typed text (absent on focus).
                            location_id 'menu_search' when the drawer was opened from the burger menu,
                            'header_search_icon' when the header magnifier opened it (same bar, kept apart).
   home_collection_click    {location_id, collection_name, link_url, tile_position}   collection tile tap
   home_carousel_swipe      {location_id, direction, tile_index}       finger swipe of the collection strip
                            (location_id 'home_collections') or the video strip ('home_videos');
                            direction = finger direction: 'left' moves to a later tile; tile_index = tile now first.
   select_item_home_best_sellers -> GA4 select_item (ecommerce: item_list_id, item_list_name, items[item_id,
                            item_name, price, index])   Best Sellers product card tap. item_id = the card's
                            variant id (the homepage prints no SKU; never a network call).
   home_carousel_arrow_click {location_id, direction, item_name_shown, index_shown}  Best Sellers < / > arrows
   home_shop_all_click      {location_id, link_text, link_url}         SHOP BEST SELLERS button
   home_video_open          {location_id, video_title, video_position}  video tile tap (opens the player);
                            video_title = the product(s) the video features, else 'Video <n>'.
   home_video_close         {location_id, video_title, video_position, watch_time_sec, video_percent}  player's X:
                            the video showing at close; watch_time_sec = seconds since the player opened;
                            video_percent = how far into that video it was (0-100).
   home_video_nav           {location_id, direction, video_before, video_after}  (row 43) the player's < / >
                            arrows: direction 'prev'/'next'; video_before/after = video position (1-based)
                            before and after the move; nothing is sent when the player did not move.
   select_item_home_essential_oils -> GA4 select_item (row 45, ecommerce: item_list_id home_essential_oils,
                            item_list_name 'Homepage Pure Essential Oils', items[item_id, item_name, price, index])
                            Pure Essential Oils product card tap; same recipe as Best Sellers (item_id = the
                            card's variant id: the homepage prints no SKU).
   Strict no-op: every listener acts only on its own element; nothing on the page is changed. */
(function () {
  'use strict';
  if (window.__nkHomeMobileEvents) return;
  window.__nkHomeMobileEvents = true;

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function closest(t, sel) { return t && t.closest ? t.closest(sel) : null; }
  function linkPath(href) {
    if (!href) return '';
    try {
      var u = new URL(href, location.origin);
      return u.origin === location.origin ? u.pathname + u.search : u.href;
    } catch (e) { return href; }
  }
  function push(o) { (window.dataLayer = window.dataLayer || []).push(o); }
  function slidesOf(splide) {
    var list = splide ? splide.querySelector('.splide__list') : null;
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (s) {
      return s.classList.contains('splide__slide') && !s.classList.contains('splide__slide--clone');
    });
  }
  function activeIndex(splide) {
    var slides = slidesOf(splide);
    for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
    return -1;
  }
  function price(el) {
    var n = parseFloat(clean(el ? el.textContent : '').replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : undefined;
  }

  var COLLECTIONS = '[class*="ai-grid-slider-container-"]';
  var VIDEOS = '.hp-shoppable-video-slider';
  function bestSellers() {
    var btn = document.querySelector('a.featured-products-slider-button[href="/collections/best-sellers"]');
    var section = btn ? btn.closest('.featured-products-slider') : null;
    return section ? section.querySelector('.featured-products-slider-products') : null;
  }
  function videoTitle(position) {
    var popup = document.querySelector('.hp-shoppable_video-popup');
    var slide = popup ? slidesOf(popup)[position - 1] : null;
    var names = slide ? Array.prototype.map.call(slide.querySelectorAll('.preview-product-title'), function (n) {
      return clean(n.textContent);
    }).filter(function (n, i, all) { return n && all.indexOf(n) === i; }) : [];
    return names.length ? names.join(' + ') : 'Video ' + position;
  }

  // ---- menu search -------------------------------------------------------------------
  var MENU_INPUT = '#shopify-section-layout--nav input.new-search-input';
  var searchEntry = 'menu_search', searchFocused = false, searchTyped = false, typeTimer = null;
  function searchPush(action, input) {
    var term = clean(input && input.value);
    push({ event: 'menu_search', location_id: searchEntry, action: action, search_term: term || undefined });
  }

  var playerOpenedAt = 0;
  var dragUntil = 0;  // a click the browser fires at the end of a mouse drag is not a tap
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (Date.now() < dragUntil) return;
    if (closest(t, '#header button[aria-label="Search"]')) { searchEntry = 'header_search_icon'; return; }
    if (closest(t, '#header button.mobile-drawer-btn')) { searchEntry = 'menu_search'; return; }

    var tile = closest(t, COLLECTIONS + ' a[href]');
    if (tile) {
      var tSlide = tile.closest('.splide__slide');
      push({ event: 'home_collection_click', location_id: 'home_collections',
             collection_name: clean((tile.querySelector('[class*="ai-grid-slider-title-"]') || tile).textContent),
             link_url: linkPath(tile.getAttribute('href')),
             tile_position: slidesOf(tile.closest('.splide')).indexOf(tSlide) + 1 });
      return;
    }

    var best = bestSellers();
    if (best && best.contains(t)) {
      var arrow = closest(t, '.splide__arrow');
      if (arrow) {
        var dir = arrow.classList.contains('splide__arrow--prev') ? 'prev' : 'next';
        setTimeout(function () {  // after the slider has moved
          var i = activeIndex(best), shown = slidesOf(best)[i];
          push({ event: 'home_carousel_arrow_click', location_id: 'home_best_sellers', direction: dir,
                 item_name_shown: clean(shown && (shown.querySelector('.collection-card-title-group') || {}).textContent),
                 index_shown: i + 1 });
        }, 600);
        return;
      }
      var card = closest(t, 'a.product-card');
      if (card) {
        var slide = card.closest('.splide__slide');
        var quick = slide.querySelector('[data-id]');
        var item = { item_id: quick ? String(quick.getAttribute('data-id')) : linkPath(card.getAttribute('href')),
                     item_name: clean((card.querySelector('.collection-card-title-group') || card).textContent),
                     price: price(slide.querySelector('.price-save-grid .text-black')),
                     index: slidesOf(best).indexOf(slide) + 1,
                     item_list_id: 'home_best_sellers', item_list_name: 'Homepage Best Sellers' };
        var variant = clean((slide.querySelector('.variant-title-grid') || {}).textContent);
        if (variant) item.item_variant = variant;
        push({ ecommerce: null });
        push({ event: 'select_item_home_best_sellers',
               ecommerce: { item_list_id: 'home_best_sellers', item_list_name: 'Homepage Best Sellers', items: [item] } });
        return;
      }
    }
    var shopAll = closest(t, 'a.featured-products-slider-button[href="/collections/best-sellers"]');
    if (shopAll) {
      push({ event: 'home_shop_all_click', location_id: 'home_best_sellers', link_text: clean(shopAll.textContent),
             link_url: linkPath(shopAll.getAttribute('href')) });
      return;
    }

    var closeBtn = closest(t, '.hp-shoppable_video-popup .popup-close');
    if (closeBtn) {
      var player = closeBtn.closest('.hp-shoppable_video-popup'), at = activeIndex(player);
      var current = slidesOf(player)[at], media = current ? current.querySelector('video') : null;
      var percent = media && media.duration ? Math.round(media.currentTime / media.duration * 100) : 0;
      push({ event: 'home_video_close', location_id: 'home_video_player', video_title: videoTitle(at + 1),
             video_position: at + 1, watch_time_sec: playerOpenedAt ? Math.round((Date.now() - playerOpenedAt) / 1000) : 0,
             video_percent: percent });
      playerOpenedAt = 0;
      return;
    }

    var video = closest(t, VIDEOS + ' .splide__slide');
    if (video) {
      playerOpenedAt = Date.now();
      var position = slidesOf(video.closest('.splide')).indexOf(video) + 1;
      push({ event: 'home_video_open', location_id: 'home_videos', video_title: videoTitle(position),
             video_position: position });
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var input = closest(e.target, MENU_INPUT);
    if (!input || searchFocused) return;
    searchFocused = true; searchTyped = false;
    searchPush('focus', input);
  }, true);
  document.addEventListener('focusout', function (e) {
    if (closest(e.target, MENU_INPUT)) searchFocused = false;
  }, true);
  document.addEventListener('input', function (e) {
    var input = closest(e.target, MENU_INPUT);
    if (!input || searchTyped) return;
    clearTimeout(typeTimer);
    typeTimer = setTimeout(function () {
      if (searchTyped || !clean(input.value)) return;
      searchTyped = true;
      searchPush('type', input);
    }, 1000);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var input = form && form.querySelector ? form.querySelector('input.new-search-input') : null;
    if (input && closest(input, '#shopify-section-layout--nav')) { clearTimeout(typeTimer); searchPush('submit', input); }
  }, true);

  // ---- swipes ------------------------------------------------------------------------
  // A swipe = the user pressed on the strip and the strip's first tile then changed.
  // Arrow / dot taps are not swipes (only the Best Sellers strip has arrows; it is not swiped here).
  var STRIPS = [[COLLECTIONS, 'home_collections'], [VIDEOS, 'home_videos']];
  var pressed = null;
  function pointX(e) { var p = e.touches && e.touches[0] || e.changedTouches && e.changedTouches[0] || e; return p.clientX || 0; }
  function press(e) {
    pressed = null;
    if (closest(e.target, '.splide__arrow, .splide__pagination')) return;
    for (var i = 0; i < STRIPS.length; i++) {
      var strip = closest(e.target, STRIPS[i][0]);
      if (strip) { pressed = { strip: strip, location: STRIPS[i][1], before: activeIndex(strip), x: pointX(e) }; return; }
    }
  }
  function release(e) {
    if (!pressed) return;
    var p = pressed; pressed = null;
    if (Math.abs(pointX(e) - p.x) > 10) dragUntil = Date.now() + 400;
    setTimeout(function () {  // after the slider has settled
      var now = activeIndex(p.strip);
      if (now < 0 || p.before < 0 || now === p.before) return;
      push({ event: 'home_carousel_swipe', location_id: p.location, direction: now > p.before ? 'left' : 'right',
             tile_index: now + 1 });
    }, 700);
  }
  ['touchstart', 'mousedown'].forEach(function (n) { document.addEventListener(n, press, { capture: true, passive: true }); });
  ['touchend', 'touchcancel', 'mouseup'].forEach(function (n) { document.addEventListener(n, release, { capture: true, passive: true }); });

  // ---- sheet rows 43 + 45 (added 2026-10-22, run 2026-10-22-homepage-mobile-3) ------------
  // Own listener: acts only on the video player's < / > arrows and the Pure Essential Oils cards;
  // everything above is unchanged.
  function essentialOils() {
    var btn = document.querySelector('a.featured-products-slider-button[href="/collections/essential-oils"]');
    var section = btn ? btn.closest('.featured-products-slider') : null;
    return section ? section.querySelector('.featured-products-slider-products') : null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (Date.now() < dragUntil) return;

    var navArrow = closest(t, '.hp-shoppable_video-popup .splide__arrow');
    if (navArrow) {
      var navPlayer = navArrow.closest('.hp-shoppable_video-popup'), before = activeIndex(navPlayer);
      var navDir = navArrow.classList.contains('splide__arrow--prev') ? 'prev' : 'next';
      setTimeout(function () {  // after the player has moved
        var after = activeIndex(navPlayer);
        if (before < 0 || after < 0 || after === before) return;
        push({ event: 'home_video_nav', location_id: 'home_video_player', direction: navDir,
               video_before: before + 1, video_after: after + 1 });
      }, 600);
      return;
    }

    var oils = essentialOils();
    if (oils && oils.contains(t)) {
      var oCard = closest(t, 'a.product-card');
      if (!oCard) return;
      var oSlide = oCard.closest('.splide__slide');
      if (!oSlide) return;
      var oQuick = oSlide.querySelector('[data-id]');
      var oItem = { item_id: oQuick ? String(oQuick.getAttribute('data-id')) : linkPath(oCard.getAttribute('href')),
                    item_name: clean((oCard.querySelector('.collection-card-title-group') || oCard).textContent),
                    price: price(oSlide.querySelector('.price-save-grid .text-black')),
                    index: slidesOf(oils).indexOf(oSlide) + 1,
                    item_list_id: 'home_essential_oils', item_list_name: 'Homepage Pure Essential Oils' };
      var oVariant = clean((oSlide.querySelector('.variant-title-grid') || {}).textContent);
      if (oVariant) oItem.item_variant = oVariant;
      push({ ecommerce: null });
      push({ event: 'select_item_home_essential_oils',
             ecommerce: { item_list_id: 'home_essential_oils', item_list_name: 'Homepage Pure Essential Oils', items: [oItem] } });
    }
  }, true);
})();
